import Vue from 'vue';
import GoogleSignInButton from 'vue-google-identity-login-btn';

Vue.use(GoogleSignInButton);
